(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["taffstyle-home-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('taffstyle-product-scroll')) {
  customElements.define('taffstyle-product-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.ts-products');
      this.controls = this.querySelector('.ts-products__controls');
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const buttons = this.controls.querySelectorAll('button');
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        const position = Math.abs(this.track.scrollLeft);
        buttons[0].disabled = position < 2;
        buttons[1].disabled = position > max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({left: Number(button.dataset.direction) * rtl * this.track.clientWidth * .86, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', this.update, {passive: true, signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taffstyle-ohr-master"]) return;
  try {
    
window.addEventListener('pageshow', () => {
  document.querySelectorAll('#taffstyle-ohr-master .tf-material-master-guide details[open]').forEach(panel => { panel.open = false; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taffstyle-product-reviews"] && !Shopify.designMode) return;
  try {
    
function openTaffstyleProductReviews(hash) {
  if (!/^#(?:looxReviews|looxReviewsFrame|tf-product-reviews-)/.test(hash)) return;
  const details = document.querySelector('.tf-product-reviews-details');
  if (details) details.open = true;
}
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin === window.location.origin && url.pathname === window.location.pathname) openTaffstyleProductReviews(url.hash);
}, true);
window.addEventListener('hashchange', () => openTaffstyleProductReviews(window.location.hash));
document.addEventListener('toggle', (event) => {
  if (event.target.matches('.tf-product-reviews-details') && event.target.open) window.dispatchEvent(new Event('resize'));
}, true);
document.addEventListener('shopify:section:load', () => openTaffstyleProductReviews(window.location.hash));
openTaffstyleProductReviews(window.location.hash);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taffstyle-storage-master"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-tf-storage-master]').forEach(root => {
      if (root.dataset.tfStorageReady) return;
      root.dataset.tfStorageReady = 'true';
      root.querySelectorAll('details').forEach(details => { details.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-tf-storage-master] details').forEach(details => { details.open = false; });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
